<template>
    <section class="content">
      <div class="loading-overlay" v-if="loading">
        <div class="spinner"></div>
        <h4>Loading Data...</h4>
      </div>
      <div class="box box-info">
        <!-- <div class="p-toolbar p-component mb-8"> -->
          <!-- <crmFollowUpDetailsDialog ref="openDialog" :showNewButton="true"/> -->
            <!-- <Dropdown 
              v-model="selectedStage"
              :options="stageFilterOptions"
              optionLabel="name"
              placeholder="Filter by Stage"
              style="width: 200px;margin: -3.5% 70%; float: right;"
            >
              <template #value="slotProps">
                <div v-if="slotProps.value" 
                     :style="{ 
                       backgroundColor: slotProps.value.color, 
                       color: getTextColor(slotProps.value.color),
                       padding: '2px 8px',
                       borderRadius: '3px'
                     }">
                  {{ slotProps.value.name }}
                </div>
                <span v-else>
                  {{ slotProps.placeholder }}
                </span>
              </template>
              <template #option="slotProps">
                <div :style="{ 
                       backgroundColor: slotProps.option.color, 
                       color: getTextColor(slotProps.option.color),
                       padding: '5px 10px'
                     }">
                  {{ slotProps.option.name }}
                </div>
              </template>
            </Dropdown> -->
        <!-- </div> -->
        <DataTable ref="po"
          :value="filteredCrmFollowUpLists"
          :paginator="true"
          :rows="100"
          :rowsPerPageOptions="[100, 500, 1000]"
          :filters="filters"
          :rowClass="rowClass"
          editMode="cell"
          class="p-datatable-responsive p-datatable-gridlines"
          :selection.sync="selectedProduct1" selectionMode="single"
        >
        <template #header v-if="this.$store.getters.modules.includes('5.38')">
              <div style="text-align: left">
                <Button icon="pi pi-external-link" label="Export" @click="exportCSV($event)" />
              </div>
            </template>
          <Column header="S.n">
            <template #body="slotProps">
            {{slotProps.index+1}}
            </template>
          </Column>
          <!-- <Column :sortable="true" header="Particular" field="particular" filterMatchMode="contains">
            <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['particular']" />
            </template>
          </Column> -->
          <Column :sortable="true" header="Client Name" field="clientName" filterMatchMode="contains" >
            <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['clientName']" />
            </template>
          </Column>
          <Column :sortable="true"
            header="Contact Person"
            field="contactPerson"
            filterMatchMode="contains"
          >
            <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['contactPerson']" />
            </template>
          </Column>
  
          <Column :sortable="true" header="Address" field="address" filterMatchMode="contains" >
            <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['address']" />
            </template>
          </Column>
  
          <Column :sortable="true" header="Contact Number" field="contactNumber"
            filterMatchMode="contains" >
            <template #body="slotProps">
            {{ formatContactNumber(slotProps.data.contactNumber) }}
          </template>
            <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['contactNumber']" />
            </template>
          </Column>
  
          <Column :sortable="true" header="Remarks-Product-Rate" field="remarks" filterMatchMode="contains" >
              <template #body="slotProps">
              <Button icon="pi pi-eye" class="p-button-raised p-button-success" @click="openRemarks(slotProps.data)" />
              </template>
          </Column>
          <!-- <Column header="Update Stage" headerStyle="width: 8em">
            <template #editor="slotProps">
            <Dropdown 
              v-model="slotProps.data.stage"
              :options="stageOptions"
              optionLabel="name"
              optionValue="value"
              placeholder="Select Stage"
              @change="updateStage(slotProps.data)"
              style="width: 100%"
            />
          </template>
          <template #body="slotProps">
                    {{ getPayStatusLabel(slotProps.data.stage) }}
                  </template>
          </Column> -->
  
          <!-- <Column :sortable="true" header="Email" field="gmail" filterMatchMode="contains" >
            <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['gmail']" />
            </template>
          </Column> -->
  
          <Column :sortable="true" header="Customer Type" field="customerType" filterMatchMode="contains" >
            <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['customerType']" />
            </template>
          </Column>
  
          <!-- <Column :sortable="true" header="Priority" field="priority" filterMatchMode="contains" >
            <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['priority']" />
            </template>
          </Column> -->
  
          <Column :sortable="true" header="Stage" field="stage" filterMatchMode="contains" >
            <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['stage']" />
            </template>
          </Column>
  
          <!-- <Column :sortable="true" header="Sample Sent" field="sampleQuotationSent" filterMatchMode="contains" >
              <template #filter>
      <InputText type="text" class="p-column-filter" v-model="filters['sampleQuotationSent']" />
    </template>
  
    <template #body="slotProps">
      {{ slotProps.data.sampleQuotationSent ? 'Yes' : 'No' }}
    </template>
            </Column> -->
  
            <!-- <Column :sortable="true" header="Quotation Sent" field="quotationSent" filterMatchMode="contains" >
              <template #filter>
      <InputText type="text" class="p-column-filter" v-model="filters['quotationSent']" />
    </template>
  
    <template #body="slotProps">
      {{ slotProps.data.quotationSent ? 'Yes' : 'No' }}
    </template>
            </Column> -->
  
  
          <Column :sortable="true" header="Updated Date Np" field="updateDateNepali" filterMatchMode="contains" >
            <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['updateDateNepali']" />
            </template>
          </Column>
  
          <Column :sortable="true" header="Next Follow Up Date Np" field="nextFollowUpDateNepali" filterMatchMode="contains" >
            <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['nextFollowUpDateNepali']" />
            </template>
          </Column>
  
          <Column header="Enter By" :sortable="true" field="enterBy" filterMatchMode="contains">
                  <template #filter>
                    <InputText type="text" class="p-column-filter" v-model="filters['enterBy']"/>
                  </template>
          </Column>
             <Column header="Update By" :sortable="true" field="updatedBy" filterMatchMode="contains">
                  <template #filter>
                    <InputText type="text" class="p-column-filter" v-model="filters['updatedBy']"/>
                  </template>
            </Column>
          
          <!-- <Column header="Action" headerStyle="width: 11em">
            <template #body="slotProps">
              <Button icon="pi pi-pencil" class="p-button-raised p-button-success" @click="editCrmFollowUp(slotProps.data)" />
              <Button icon="pi pi-trash" class="p-button-danger p-button-sm" @click="openDialog(slotProps.data.id)"/>
            </template>
          </Column> -->
        </DataTable>
      </div>
      <Dialog v-model="dialogShow" @cancel="cancel" @deleted="deleteCrmFollowUp"/>
  
      <remarksDialog
      :visible="dialogVisible"
      :style="{ width: '500px' }"
      :header=clientName
      :modal="true"
      class="p-fluid"
    >
    <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col-12 p-md-6">
          <label for="productName">Products <span style="color:red"></span></label>
          <Textarea
            id="productName"
            v-model="productName"
            rows="2"
            autoResize
          />
        </div>
  
     
        <div class="p-field p-col-12 p-md-6">
          <label for="rate">Rate <span style="color:red"></span></label>
          <Textarea
            id="rate"
            v-model="rate"
            rows="2"
            autoResize
          />
        </div>
      </div>
      <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col-12 p-md-6">
          <label for="remarks">Remarks <span style="color:red"></span></label>
          <Textarea
            id="remarks"
            v-model="remarks"
            rows="3"
            autoResize
          />
        </div>
        <div class="p-field p-col-12 p-md-6">
          <label for="remarks1">Remarks 1</label>
          <Textarea
            id="remarks1"
            v-model="remarks1"
            rows="3"
            autoResize
          />
        </div>
        <div class="p-field p-col-12 p-md-6">
          <label for="remarks2">Remarks 2</label>
          <Textarea
            id="remarks2"
            v-model="remarks2"
            rows="3"
            autoResize
          />
        </div>
      </div>
      <template #footer>
        <Button
          label="Close"
          icon="pi pi-times"
          class="p-button p-button-raised p-button-danger"
          @click="closeRemarks"
        />
      </template>
    </remarksDialog>
  
    <remarksDialog
      :visible="productVisible"
      :style="{ width: '500px' }"
      header="Products"
      :modal="true"
      class="p-fluid"
    >
      <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col-12 p-md-6">
          <label for="productName">Product Name <span style="color:red"></span></label>
          <Textarea
            id="productName"
            v-model="productName"
            rows="3"
            autoResize
          />
        </div>
  
      </div>
      <template #footer>
        <Button
          label="Close"
          icon="pi pi-times"
          class="p-button p-button-raised p-button-danger"
          @click="closeProductName"
        />
      </template>
    </remarksDialog>
    </section>
  </template>
  
  <script>
  import crmFollowUpDetailsDialog from '../crmDialog/crmFollowUpDetailsDialog.vue'
  import Column from 'primevue/column'
  import DataTable from 'primevue/datatable'
  import Dialog from '../../layout/dialog'
  // import globalKey from '../../../store/globalKey'
  // import axios from 'axios'
  import InputText from 'primevue/inputtext'
  import Button from 'primevue/button'
  import remarksDialog from 'primevue/dialog'
  import Textarea from 'primevue/textarea'
  import Dropdown from 'primevue/dropdown'
  export default {
    name: 'followUpList',
    data() {
      return {
        displayBasic: false,
        dialogShow: false,
        columnList: '',
        accountId: null,
        loading: true,
        filters: {},
        remarks: '',
        remarks1: '',
        remarks2: '',
        clientName: '',
        dialogVisible: false,
        productVisible: false,
        selectedStage: null,
        selectedProduct1: null,
        stageFilterOptions: [
          { name: 'All Stages', value: null, color: '#FFFFFF' },
          { name: 'Order', value: 'order', color: '#00FF00' },
          { name: 'Deal', value: 'deal', color: '#FFA500' },
          { name: 'System not used', value: 'system not used', color: '#FF0000' },
          { name: 'Initial', value: 'initial', color: '#FFFFFF' },
          { name: 'Sample', value: 'sample', color: '#FFFF00' },
          { name: 'Visit', value: 'visit', color: '#87CEEB' },
          { name: 'Need software', value: 'need software', color: '#800080' },
          { name: 'Currently Have Stock', value: 'currently have stock', color: '#800180' },
          { name: 'Incorrect Number', value: 'incorrect number', color: '#802080' },
          { name: 'Irritated', value: 'irritated', color: '#803380' },
          { name: 'Lead', value: 'lead', color: '#801180' },
          { name: 'Vendor Change Garna Manena', value: 'Vendor Change Garna Manena', color: '#802280' },
          { name: 'Closed', value: 'Closed', color: '#809980' }
        ],
        productName: '',
        rate: '',
        rowClassCache: new Map(),
        selectedUser: null,
        rowColors: {},
        stageOptions: [
          { name: 'All', value: null, color: '#FFFFFF' },
          { name: 'Order', value: 'order', color: '#00FF00' },
          { name: 'Deal', value: 'deal', color: '#FFA500' },
          { name: 'System not used', value: 'system not used', color: '#FF0000' },
          { name: 'Initial', value: 'initial', color: '#FFFFFF' },
          { name: 'Sample', value: 'sample', color: '#FFFF00' },
          { name: 'Visit', value: 'visit', color: '#87CEEB' },
          { name: 'Need software', value: 'need software', color: '#800080' },
          { name: 'Currently Have Stock', value: 'currently have stock', color: '#800180' },
          { name: 'Incorrect Number', value: 'incorrect number', color: '#802080' },
          { name: 'Irritated', value: 'irritated', color: '#803380' },
          { name: 'Lead', value: 'lead', color: '#801180' },
          { name: 'Vendor Change Garna Manena', value: 'Vendor Change Garna Manena', color: '#802280' },
          { name: 'Closed', value: 'Closed', color: '#809980' }
        ]
      }
    },
    computed: {
      crmAllFollowUpLists() {
        return this.$store.state.crm.crmAllFollowUpLists
      },
      filteredCrmFollowUpLists() {
        if (!this.selectedStage || !this.selectedStage.value) {
          return this.crmAllFollowUpLists
        }
        return this.crmAllFollowUpLists.filter(
          item => item.stage === this.selectedStage.value
        )
      }
    },
    watch: {
      crmAllFollowUpLists: {
        immediate: true,
        deep: true,
        handler() {
          this.generateRowClassCache()
        }
      }
    },
    mounted() {
      this.crmAllFollowUpList()
      this.columnNames()
      this.generateRowClassCache()
    },
    methods: {
      getTextColor(bgColor) {
        if (!bgColor) return '#000000'
        const color = bgColor.charAt(0) === '#' ? bgColor.substring(1, 7) : bgColor
        const r = parseInt(color.substring(0, 2), 16)
        const g = parseInt(color.substring(2, 4), 16)
        const b = parseInt(color.substring(4, 6), 16)
        return r * 0.299 + g * 0.587 + b * 0.114 > 186 ? '#000000' : '#FFFFFF'
      },
      getPayStatusLabel(payStatus) {
        switch (payStatus) {
          case 'order':
            return 'Order'
          case 'deal':
            return 'Deal'
          case 'system not used':
            return 'System not used'
          case 'initial':
            return 'Initial'
          case 'sample':
            return 'Sample'
          case 'visit':
            return 'Visit'
          case 'need software':
            return 'Need software'
          default:
            return 'NA'
        }
      },
      generateRowClassCache() {
        this.rowClassCache.clear()
        this.crmAllFollowUpLists.forEach(item => {
          const className = this.getRowClassName(item)
          this.rowClassCache.set(item.id, className)
        })
      },
      getRowClassName(data) {
        if (!data.stageColor) return ''
        const colorKey = data.stageColor.replace(/#/g, 'c')
        return `row-color-${colorKey}`
      },
      rowClass(data) {
        return this.rowClassCache.get(data.id) || ''
      },
      async deleteCrmFollowUp(value) {
        if (value.trim() === '') {
          this.$toast.add({severity: 'error', summary: '', detail: 'Delete reason cannot be empty!', life: 10000})
          this.dialogShow = true
          return
        }
        let deleteRe = {
          id: this.accountId,
          deleteReason: value
        }
        let resp = await this.$store.dispatch('deleteCrmFollowUp', deleteRe)
        if (resp.data.status === 'SUCCESS') {
          this.$toast.add({severity: 'success', summary: '', detail: resp.data.message, life: 10000})
          this.closeDialog()
          this.dialogShow = false
          await this.crmAllFollowUpList()
        } else {
          this.$toast.add({severity: 'error', summary: '', detail: resp.data.message, life: 10000})
          this.dialogShow = false
          this.closeDialog()
        }
      },
      selectRow(user) {
        this.selectedUser = user
      },
      formatContactNumber(num) {
        if (!num) return ''
        const clean = num.toString().replace(/\D/g, '').substring(0, 10)
        return clean
      },
      editCrmFollowUp(data) {
        this.$refs.openDialog.editCrmFollowUp(data)
      },
      // rowStyle(data) {
      //   console.log('rowStyle called for:', data)
      //   console.log('Row ID:', data.id, 'Color:', this.rowColors[data.id])
      //   const color = this.rowColors[data.id]
      //   if (color) {
      //     return { backgroundColor: `${color} !important` }
      //   }
      //   return null
      // },
      // loadSavedColors() {
      //   const savedColors = localStorage.getItem('rowColors')
      //   if (savedColors) {
      //     try {
      //       this.rowColors = JSON.parse(savedColors)
      //     } catch (e) {
      //       console.error('Error loading colors:', e)
      //     }
      //   }
      // },
      async updateStage(data) {
        const option = this.stageOptions.find(opt => opt.value === data.stage)
        const stageColor = option ? option.color : ''
        const followUp = {
          id: data.id,
          stage: data.stage,
          stageColor: stageColor
        }
        try {
          const resp = await this.$store.dispatch('updateStageFollowUp', followUp)
          if (resp.data.status === 'SUCCESS') {
            const className = this.getRowClassName(data)
            this.rowClassCache.set(data.id, className)
            data.stageColor = stageColor
            this.$toast.add({
              severity: 'success',
              summary: '',
              detail: resp.data.message,
              life: 10000
            })
          }
        } catch (error) {
          this.$toast.add({
            severity: 'error',
            summary: 'Update Failed',
            detail: 'Error updating stage',
            life: 10000
          })
        }
      },
      exportCSV() {
        this.$refs.po.exportCSV()
      },
      // exportCSV() {
      //   let data = {
      //     columnList: this.columnList
      //   }
      //   axios({
      //     url: globalKey + '/fileDownload/excelReportAccount/' + this.$store.getters.organisationId + '/' + this.$store.getters.userId + '/CRM Follow-up List' + '/' + this.$store.getters.fyId + '/' + data.columnList,
      //     method: 'get',
      //     headers: {
      //       'Accept': 'application/vnd.ms-excel',
      //       'Authorization': localStorage.token
      //     },
      //     responseType: 'blob'
      //   }).then((response) => {
      //     const url = window.URL.createObjectURL(new Blob([response.data]), {type: response.data.type})
      //     const link = document.createElement('a')
      //     const contentDisposition = response.headers['content-disposition']
      //     let fileName = 'crmFollowUpList.xlsx'
      //     if (contentDisposition) {
      //       const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
      //       if (fileNameMatch && fileNameMatch.length === 2) {
      //         fileName = fileNameMatch[1]
      //       }
      //     }
      //     link.href = url
      //     link.setAttribute('download', fileName)
      //     document.body.appendChild(link)
      //     link.click()
      //     link.remove()
      //     window.URL.revokeObjectURL(url)
      //   })
      // },
      columnNames() {
        this.columnList = ''
        for (let i = 0; i < this.$refs.po.columns.length; i++) {
          if (this.$refs.po.columns[i].header && this.$refs.po.columns[i].header !== 'Action' && this.$refs.po.columns[i].header !== 'S.n') {
            this.columnList += this.$refs.po.columns[i].header + ','
          }
        }
        this.columnList = this.columnList.slice(0, -1)
      },
      async crmAllFollowUpList() {
        this.loading = true
        try {
          let res = await this.$store.dispatch('loadCrmAllFollowUpList')
          return res
        } finally {
          this.loading = false
        }
      },
      openRemarks(data) {
        this.remarks = data.remarks
        this.remarks1 = data.remarks1
        this.remarks2 = data.remark2
        this.dialogVisible = true
        this.clientName = data.clientName + '  Remakrs'
        this.productName = data.products.join(', ')
        this.rate = data.rate
      },
      openProduct(data) {
        this.productName = data.products.join(', ')
        this.productVisible = true
      },
      closeRemarks() {
        this.dialogVisible = false
      },
      closeProductName() {
        this.productVisible = false
      },
      openDialog(id) {
        this.dialogShow = true
        this.accountId = id
      },
      closeDialog() {
        this.dialogShow = false
      },
      cancel() {
        this.dialogShow = false
      }
    },
    components: {
      Column,
      DataTable,
      Dialog,
      InputText,
      crmFollowUpDetailsDialog,
      Button,
      remarksDialog,
      Textarea,
      Dropdown
    }
  }
  </script>
  <style>
  .row-color-c00FF00 { background-color: #00FF00 !important; color: #000000 !important; }
  .row-color-cFFA500 { background-color: #FFA500 !important; color: #000000 !important; }
  .row-color-cFF0000 { background-color: #FF0000 !important; color: #FFFFFF !important; }
  .row-color-cFFFF00 { background-color: #FFFF00 !important; color: #000000 !important; }
  .row-color-c87CEEB { background-color: #87CEEB !important; color: #000000 !important; }
  .row-color-c800080 { background-color: #800080 !important; color: #FFFFFF !important; }
  .row-color-800180 { background-color: #800180 !important; color: #FFFFFF !important; }
  .row-color-802080 { background-color: #802080 !important; color: #FFFFFF !important; }
  .row-color-803380 { background-color: #803380 !important; color: #FFFFFF !important; }
  .row-color-801180 { background-color: #801180 !important; color: #FFFFFF !important; }
  .row-color-801180 { background-color: #801180 !important; color: #FFFFFF !important; }
  .row-color-809980 { background-color: #809980 !important; color: #FFFFFF !important; }
  .p-dropdown-item {
    padding: 0.5rem 1rem;
    border-radius: 3px;
  }
  .p-datatable .p-datatable-tbody > tr.p-highlight {
      background: #EFF6FF;
      color: #1D4ED8;
  }
  .loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.85);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 9999;
  }
  
  .spinner {
    width: 60px;
    height: 60px;
    border: 6px solid #f3f3f3;
    border-top: 6px solid #3498db;
    border-radius: 50%;
    animation: spin 1.5s linear infinite;
    margin-bottom: 20px;
  }
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
  
  .loading-overlay h4 {
    font-size: 1.5rem;
    color: #2c3e50;
  }
  </style>



// WEBPACK FOOTER //
// crmAllList.vue?420d7036